export const products = [
  {
    name: "Harry Potter and the half-blood prince",
    writer: "jk rowling",
    price: 35,
    offPrice: 21,
    src: "https://images-na.ssl-images-amazon.com/images/I/71HAU27ETJL.jpg",
    id: 1,
  },
  {
    name: "Sherlock holmes kizil saclilar kulubu",
    writer: "Altunkanat",
    price: 25,
    offPrice: 20,
    src: "https://img.kitapyurdu.com/v1/getImage/fn:11301258/wh:true/wi:800",
    id: 2,
  },
  {
    name: "The lord of the rings the two towers",
    writer: "j. r. r. tolkien",
    price: 18,
    offPrice: 15,
    src: "https://images.saymedia-content.com/.image/t_share/MTc0MzkwMjYxNjg0NjQzMTc2/should-i-watch-the-lord-of-the-rings-the-two-towers.jpg",
    id: 3,
  },
  {
    name: "The ethan i was before",
    writer: "Ali standish",
    price: 7,
    offPrice: 5,
    src: "https://images-na.ssl-images-amazon.com/images/I/61SDHEX3-SL.jpg",
    id: 4,
  },
  {
    name: "The champion of the world",
    writer: "Roald dahl",
    price: 12,
    offPrice: 8,
    src: "https://upload.wikimedia.org/wikipedia/en/2/28/DannyChampionOfTheWorld.JPG",
    id: 5,
  },
  {
    name: "Walking on the moon with einstein",
    writer: "Joshua foer",
    price: 16,
    offPrice: 10,
    src: "https://images-na.ssl-images-amazon.com/images/I/41LTPLNF5tL._SX324_BO1,204,203,200_.jpg",
    id: 6,
  },
  {
    name: "Walking on the moon with einstein",
    writer: "David j schwartz",
    price: 8,
    offPrice: 4,
    src: "https://images-na.ssl-images-amazon.com/images/I/51BE61A0SXL.jpg",
    id: 7,
  },
  {
    name: "Tiny changes remarkable results atomic habits",
    writer: "James clear",
    price: 8,
    offPrice: 4,
    src: "https://images-na.ssl-images-amazon.com/images/I/51-nXsSRfZL._SX328_BO1,204,203,200_.jpg",
    id: 8,
  },
  {
    name: "5 second rule",
    writer: "Mel robbins",
    price: 16,
    offPrice: 12,
    src: "https://kbimages1-a.akamaihd.net/117a2850-f7f0-4394-8646-1e8471ddec8b/1200/1200/False/the-5-second-rule.jpg",
    id: 9,
  },
  {
    name: "Soar Build Your Vision from the Ground Up",
    writer: "T. D. Jakes",
    price: 11,
    offPrice: 5,
    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLz0ceEze7n1htgr2ybahdWqFCHjwj3-H_tesxVb69LqV1S4cv",
    id: 10,
  },
];
